import { fetchAPI } from "packs/api";

const hideTimeouts = new Map();

function setReactions() {
  const containers = document.querySelectorAll('.reactions-container.show-reaction');
  containers.forEach(container => {
    container.addEventListener('mouseenter', handleMouseEnter);
    container.addEventListener('mouseleave', handleMouseLeave);
  });
}

function handleMouseEnter(event) {
  const container = event.currentTarget;
  const reactionPopup = container.querySelector('.reaction-popup');
  if (!reactionPopup) return;
  const postId = reactionPopup.dataset.id;
  let reactionsDiv = document.querySelector(`.reactions_${postId}`);
  
  // Create reactions div if it doesn't exist
  if (!reactionsDiv) {
    reactionsDiv = document.createElement('div');
    reactionsDiv.className = `reactions_${postId} absolute bottom-[20px] border border-light-border dark:border-dark-border z-30 rounded-full shadow-lg bg-white dark:bg-background-btn-dark px-3 !hidden reactions`;
    container.appendChild(reactionsDiv);
  }
  
  if (reactionsDiv.dataset.loaded == "false" || reactionsDiv.dataset.loaded == undefined) {
    const reactions = window.appconfig?.reactions;
    if (!reactions) return;
  
    const html = `
      <div class="flex items-center h-10">
        ${reactions.map((reaction, i) => `
          <div class="${(i === reactions.length - 1 ) ? '' : 'pr-3'}">
            <a class="cursor-pointer hover:scale-110 transition-all block w-6 reaction-icon" data-method="put" href="/posts/voteup?id=${postId}&reaction_id=${reaction.id}" data-remote="true" data-post-id="${postId}" data-reaction-id="${reaction.id}">
              <img src="${reaction.src}" alt="${reaction.name}" loading="lazy" class="w-[30px] h-auto max-h-[30px]" />
            </a>
          </div>
        `).join('')}
      </div>
    `;
    reactionsDiv.innerHTML = html;
    reactionsDiv.dataset.loaded = true;
  }

  clearTimeout(hideTimeouts.get(postId));

  reactionsDiv.style.maxWidth = '';
  reactionsDiv.classList.add('active');
  reactionsDiv.classList.remove('!hidden');
}

function handleMouseLeave(event) {
  const container = event.currentTarget;
  const reactionPopup = container.querySelector('.reaction-popup');
  if (!reactionPopup) return;
  const postId = reactionPopup.dataset.id;
  const reactionsDiv = document.querySelector(`.reactions_${postId}`);
  if (!reactionsDiv) return;

  const hideTimeout = setTimeout(() => {
    reactionsDiv.style.maxWidth = '0px';
    reactionsDiv.classList.remove('active');

    setTimeout(() => {
      reactionsDiv.innerHTML = '';
      reactionsDiv.dataset.loaded = false;
      reactionsDiv.classList.add('!hidden');
    }, 100);
  }, 500);

  hideTimeouts.set(postId, hideTimeout);
}

document.addEventListener("DOMContentLoaded", function() {
  setReactions();
})

window.setReactions = setReactions;